<template>
  <v-container v-if="isAgent">
    <v-row>
      <v-col>
        <CurrentCases :agentEmail="returnAgent()" />
      </v-col>
      <v-col>
        <v-card height="480" max-height="480">
          <v-toolbar color="primary" dark fixed>
            <v-toolbar-title>Service Status</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-chip v-if="statuses.length > 0" color="red">
              <v-icon>mdi-alert</v-icon>
              : {{ statuses.length }}
            </v-chip>
          </v-toolbar>
          <v-card-text class="overflow-auto" style="height: 400px">
            <v-simple-table class="overflow-auto" v-if="statuses.length > 0">
              <template v-slot:default>
                <thead>
                  <tr>
                    <th class="text-left">Service</th>
                    <th class="text-left">Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(service, index) in statuses"
                    :key="index"
                    :class="{ 'red--text': service.status == 'down' }"
                  >
                    <td>{{ service.friendly_name || service.url }}</td>
                    <td>
                      <!-- Hover -->
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            :color="statusMap[service.status].color"
                            >{{ statusMap[service.status].icon }}</v-icon
                          >
                        </template>
                        <span>{{ statusMap[service.status].text }}</span>
                      </v-tooltip>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            <v-alert v-else type="success"> All services are up! </v-alert>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="3">
        <CurrentQueueVue />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <DailyUpdates :agentEmail="returnAgent()" />
      </v-col>
    </v-row>
  </v-container>
  <v-container v-else>
    <v-row class="text-center">
      <v-col cols="12">
        <v-img
          :src="require('../assets/icon.png')"
          class="my-3"
          contain
          height="250"
        />
      </v-col>

      <v-col class="mb-4">
        <h1 class="display-2 font-weight-bold mb-3">Welcome to Support Bot</h1>

        <p class="subheading font-weight-regular">
          For all your queue management needs and more!
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "@/plugins/axios";
import DailyUpdates from "@/components/DailyUpdates.vue";
import CurrentCases from "@/components/CurrentCases.vue";
import CurrentQueueVue from "@/components/home/CurrentQueue.vue";
export default {
  name: "HomeView",
  components: {
    DailyUpdates,
    CurrentQueueVue,
    CurrentCases,
  },
  data() {
    return {
      error: null,
      isAgent: false,
      statuses: [],
      loaded: false,
      statusMap: {
        0: {
          color: "blue",
          text: "Paused",
          icon: "mdi-pause",
        },
        1: {
          color: "gray",
          text: "Not Checked Yet",
          icon: "mdi-clock",
        },
        2: {
          color: "green",
          text: "Up",
          icon: "mdi-check",
        },
        8: {
          color: "purple",
          text: "Seems Down",
          icon: "mdi-alert",
        },
        9: {
          color: "red",
          text: "Down",
          icon: "mdi-alert",
        },
      },
    };
  },
  mounted() {
    let that = this;
    axios.get(`/api/v1/bot-home/agent/${localStorage.username}`).then((res) => {
      if (res.data) {
        that.isAgent = true;
        that.loaded = true;
      }
    });
    this.updateStatuses();
    setInterval(
      () => {
        this.updateStatuses();
      }, //60 seconds
      60000
    );
  },
  methods: {
    updateStatuses() {
      axios.get("/api/v1/uptime").then((res) => {
        let down = [];
        res.data.forEach((item) => {
          if ((item.status === 9) | (item.status === 8)) {
            down.push(item);
          }
        });
        this.statuses = down;
      });
    },
    returnAgent() {
      return localStorage.username;
    },
  },
};
</script>
